import { createApiRequest } from "../common";
import { ListOrgInvitesRequestContent as ListOrgInvitesRequestContentv2, ListOrgInvitesResponseContent as ListOrgInvitesResponseContentv2 } from '@equaliq/api-model';
import { ListOrgInvitesRequestContent, ListOrgInvitesResponseContent } from '@equaliq/api-model';

export const listOrgInvitesApi = async (request: ListOrgInvitesRequestContent): Promise<ListOrgInvitesResponseContent> => {
  const apiRequest = createApiRequest<ListOrgInvitesResponseContent>('post', '/orgs/invites/list');
  return apiRequest(request);
};

export const listOrgInvitesApiv2 = async (request: ListOrgInvitesRequestContentv2): Promise<ListOrgInvitesResponseContentv2> => {
  const apiRequest = createApiRequest<ListOrgInvitesResponseContentv2>('post', '/orgs/invites/list');
  return apiRequest(request);
};
